import React, { useState } from 'react';
import SecTitle from '../common/sectitle.jsx';
import Btn from '../../components/common/btn.jsx';
import { Link } from 'react-router-dom';
import './vendors.css';

import diwanLogo from '../../assets/icons/diwanLogo.svg';
import bibliothekLogo from '../../assets/icons/bibliothekLogo.svg';
import arrow from '../../assets/icons/arrow.svg';
import arrowFlipped from '../../assets/icons/arrowFlipped.svg';

const vendors = [
  { id: 1, logo: diwanLogo, name: 'Diwan' },
  { id: 2, logo: bibliothekLogo, name: 'Bibliothek' },
  { id: 3, logo: diwanLogo, name: 'Aseer El Kotob' },
];

const VendorsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const prev = () =>
    setActiveIndex((i) => (i - 1 + vendors.length) % vendors.length);
  const next = () =>
    setActiveIndex((i) => (i + 1) % vendors.length);

  const getVendor = (offset) =>
    vendors[(activeIndex + offset + vendors.length) % vendors.length];

  return (
    <section id="vendors">
      <SecTitle secTitle="{ Our Top Exhibitors }" secDesc="Don't forget to pass by them" />

      <div className="carousel-wrapper">
        <button className="carousel-arrow left" onClick={prev}><img src={arrowFlipped} alt="arrow" /></button>

        <div className="cards">
          <div className="card card-side">
            <img src={getVendor(-1).logo} alt={getVendor(-1).name} />
          </div>

          <div className="card card-center">
            <img src={getVendor(0).logo} alt={getVendor(0).name} />
          </div>

          <div className="card card-side">
            <img src={getVendor(1).logo} alt={getVendor(1).name} />
          </div>
        </div>

        <button className="carousel-arrow right" onClick={next}><img src={arrow} alt="arrow" /></button>
      </div>

      <Link className="link" to="/Explore">
      <Btn btnStyle="mainBtn" btnText="Explore More" />
      </Link>
    </section>
  );
};

export default VendorsSection;